import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  open() {
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  dismiss(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  disconnect() {
    this.close()
  }
}
